import axios from 'axios';
import { AccumulatorChartDataList } from '../../interfaces/AccumulatorChart/types';
import { getCsrftoken } from '../../helpers/csfrToken';
import { restErrorHandler } from '../../helpers/restErrorHandler';
import { CustomDateRangeParams } from '../../interfaces/DatePicker/v2/types';

export type ModelName = {
    id: number;
    name: string;
}

export type AccumulatorActivity = {
    id: number;
    name: string;
}

export type Building = {
    id: number,
    building_name: string
}


export type StatusCount = {
    TypeMessage: number,
    count: number
}


export type AccumulatorDetails = {
    id: number;
    accumulator_model_name: ModelName | null;
    accumulator_activity: AccumulatorActivity | null;
    building_id?: Building;
    device_type: string;
    online_date: string;
    soh:number,
    charge: number;
    discharge: number;
    cycles: number | null;
    part_cycles: number | null;
    created_at: string; // You can use Date if you're parsing it to a Date object
    serial_number: string;
    manufacture_date: string | null;
    comment: string | null;
    accum_image: string | null;
    is_configured: boolean;
    custom_name: string | null;
    exploatation_date: string | null;
    voltage: number | null;
    nominal_capacity: number | null;
    status: number;
    last_init_time: string | null;
    status_counts: StatusCount[];
    is_commissioned: boolean;
    bms_model: string;
    coordinates: {
        Latitude: string;
        Longitude: string;
    } | null;
    customer_comment: string | null;
    image : {
        image: string
    } | null;
    client_device_type: {
        device_name: string;
    }
    accumulator_external_remote_control_hw_version?: string;
    accumulator_external_remote_control_fw_version?: string;
    sim_card_number?: string;
    gsm_imei?:string;
    wifi_ssid?: string;
    wifi_password?: string;
    bms_hw_version?: string;
    bms_fw_version:string;
}


export const fetchAcbDetails = async (role: string, serialNumber: string, setter : (value: AccumulatorDetails) => void) => {
    axios.get<AccumulatorDetails>(`${process.env.REACT_APP_DJANGO_SERVER_URL}/api/${role}/v1/acb/${serialNumber}/details`,
        { withCredentials: true }
    )
    .then(response => {
        if (response.status === 200) {
            var data: AccumulatorDetails = response.data
            setter(data)
        }
    })
    .catch(error => {
        restErrorHandler(error.status)
        console.error('Error fetching accumulator details:', error);
        // Handle the error accordingly
    });
}


export type ChartDataResponse = {
    data : AccumulatorChartDataList | null;
}


// export const FetchChartData = async (role: string, serialNumber: string, dateRangeValues: DateRangeProps | null) => {
//     const payload: Record<string, string> = {
//         serial_number: serialNumber,
//     }

//     if (dateRangeValues !== null) {
//         payload['start'] = dateRangeValues.start.slice(0, 10)
//         payload['end'] = dateRangeValues.start.slice(0, 10)
//     } 

//     const data = axios.post<ChartDataResponse>(`${process.env.REACT_APP_DJANGO_SERVER_URL}/api/${role}/v1/acb/${serialNumber}/charts`,
//         { payload },
//         { 
//             headers: {
//                 'X-CSRFToken': getCsrftoken(),
//                 'Content-Type': 'application/json'
//             },
//             withCredentials: true 
//         }
//     )
//     .then(response => {
//             if (response.status === 200) {
//                 var data: any = response.data
//                 if (data === "") {
//                     data = undefined
//                 }
//                 setter(data)
//             }
//         }
//     )
//     .catch(error => {
//         console.error('Error fetching chart data details:', error);
//         // Handle the error accordingly
//     });
// }

export const fetchChartData = async (
    role: string,
    serialNumber: string,
    dateRangeValues: CustomDateRangeParams,
    trunc?: string
): Promise<ChartDataResponse> => {
    const payload: Record<string, string> = {
        serial_number: serialNumber,
    };

    if (dateRangeValues?.start) {
        payload.start = dateRangeValues?.start?.slice(0, 10);
    }

    if (dateRangeValues?.end) {
        payload.end = dateRangeValues?.end?.slice(0, 10); 
    }

    if (trunc) {
        payload.trunc = trunc
    } else {
        payload.trunc = 'hour'
    }

    try {
        const response = await axios.post<ChartDataResponse>(
            `${process.env.REACT_APP_DJANGO_SERVER_URL}/api/${role}/v1/acb/${serialNumber}/charts`,
            payload,
            {
                headers: {
                    "X-CSRFToken": getCsrftoken(),
                    "Content-Type": "application/json",
                },
                withCredentials: true,
            }
        );

        return response.data;
    } catch (error) {
        console.error("Error fetching chart data details:", error);
        throw error; // allow caller to handle it
    }
};

